import { useTranslation } from "react-i18next";
import BasicButton from "../../../components/BasicButton";
import { itemTypes } from "../../../data/types/itemTypes";
import { colors } from "../../../data/colors";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CloudIcon from "@mui/icons-material/Cloud";
import BlockIcon from "@mui/icons-material/Block";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useMainContext } from "../../../context/MainContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useEffect, useState } from "react";
import { sendData } from "../../../services/sendData";
import { stdObject } from "../../../data/types/stdObject";
import { openDownloadModal } from "../functions/openDownloadModal";

export default function MenuHeader({
  askLogout,
  changeBranch,
  activeDoc,
  alarms,
}: {
  askLogout: () => void;
  changeBranch: () => void;
  activeDoc: number;
  alarms: number;
}) {
  const { t } = useTranslation();
  const [download, setDownload] = useState<stdObject>({
    internet: "ok",
    total: 0,
  });
  const user: any = useSelector((state: RootState) => state.data.user);
  const {
    mainMenuheader,
    setMainMenuHeader,
    openActiveDocList,
    openNotifications,
    openCalendar,
    setMsg,
    setModalData,
    logoutAction,
  } = useMainContext();
  const { type, Icon } = mainMenuheader;

  const checkDownload = async () => {
    const responseDownload = await sendData({
      endPoint: "checkDownload",
      logoutAction,
    });
    console.log("responseDownload: ", responseDownload);

    let seconds = 10;
    const { success, status, total, error } = responseDownload;
    if (success && status) {
      seconds = 5;
      const tempDownload = download;
      if (tempDownload.internet !== true) {
        tempDownload.internet = true;
      }
      tempDownload.total = total;
      setDownload({ ...tempDownload });
    } else {
      if (download.internet !== error) {
        setDownload({
          ...download,
          internet: error ?? "error",
        });
      }
    }
    setTimeout(checkDownload, seconds * 60000);
  };

  useEffect(() => {
    if (user.DWNUSU) {
      checkDownload();
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: type in colors ? colors[type] : colors.lightGrey2,
      }}
    >
      <div style={{ flex: 1, padding: 3 }}>
        {typeof type === "string" ? (
          <div
            className="screenBar"
            onClick={() =>
              setMainMenuHeader({
                type: false,
                id: "",
                Icon: CheckBoxOutlineBlankIcon,
              })
            }
          >
            <div className="iconBar">
              <Icon />
            </div>
            <span style={{ fontSize: 22 }}>{t(`p.${type}`)}</span>
          </div>
        ) : (
          <div
            className="screenBar"
            style={{ cursor: user.MULUSU ? "pointer" : "default" }}
            onClick={user.MULUSU ? changeBranch : () => {}}
          >
            {user.NOMSUC}
          </div>
        )}
      </div>
      {!!user.DWNUSU && (
        <div
          style={{ position: "relative" }}
          onClick={() =>
            openDownloadModal(download, { t, setMsg, setModalData })
          }
        >
          {download.internet === true ? (
            <CloudDownloadIcon
              className="webDownloadIcon"
              style={{
                transform: "translateY(5px)",
                color:
                  download.total > 0 ? colors.lightGreen2 : colors.lightGrey,
              }}
            />
          ) : (
            <CloudIcon
              className="webDownloadIcon"
              style={{
                transform: "translateY(0px)",
                color: colors.lightGrey,
              }}
            />
          )}
          <div className="webDownloadText">
            {download.internet === true ? (
              download.total
            ) : !download.internet ? (
              <PriorityHighIcon
                style={{
                  position: "absolute",
                  top: 6,
                  left: 8,
                  fontSize: 14,
                  color: colors.red,
                }}
              />
            ) : (
              <BlockIcon
                style={{
                  position: "absolute",
                  top: 6,
                  left: 8,
                  fontSize: 14,
                  color: colors.red,
                }}
              />
            )}
          </div>
        </div>
      )}
      {user.ALAROL > 0 && (
        <div style={{ padding: 3, marginRight: 10 }}>
          <BasicButton
            onClick={openNotifications}
            title={alarms.toString()}
            color={colors.green}
            Icon={NotificationsIcon}
          />
        </div>
      )}
      {user.CALROL > 0 && (
        <div style={{ padding: 3, marginRight: 10 }}>
          <BasicButton
            onClick={openCalendar}
            color={colors.green}
            Icon={CalendarMonthIcon}
          />
        </div>
      )}
      {activeDoc > 0 && (
        <div style={{ padding: 3, marginRight: 10 }}>
          <BasicButton
            onClick={openActiveDocList}
            title={activeDoc.toString()}
            color={colors.red}
            Icon={InsertDriveFileIcon}
          />
        </div>
      )}
      <div style={{ padding: 3 }}>
        <BasicButton
          onClick={askLogout}
          title={t("p.logout")}
          color={colors.red}
          Icon={PowerSettingsNewIcon}
        />
      </div>
    </div>
  );
}
